const Checkout = () => import(/* webpackChunkName: "checkout" */ '@/modules/checkout/views/Checkout')
const CheckoutSuccess = () => import(/* webpackChunkName: "checkout" */ '@/modules/checkout/views/CheckoutSuccess')

import Auth from '@/services/Auth'

export default [
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout,
    beforeEnter: Auth.isLoggedIn,
    meta: {
      title: 'Checkout'
    }
  },
  {
    path: '/checkout/success/:id',
    name: 'CheckoutSuccess',
    component: CheckoutSuccess,
    beforeEnter: Auth.isLoggedIn,
    meta: {
      title: 'Checkout'
    }
  }
]
